import(/* webpackMode: "eager" */ "/tmp/build_9d801687/lifemeasure-frontend/src/app/layout.js");
